import React from 'react';
import { ExportIcon, IconSpinner } from '../../../assets/icons/icons';
import { Button } from '../../ui/Button/Button';
import { FilterBar, FilterSearch, FilterSpacer } from '../../ui/FilterBar/FilterBar';
import styles from './SizesToolbar.module.scss';

interface SizesToolbarProps {
    query: string;
    placeholder: string;
    onQueryChange: (value: string) => void;
    onExport: () => void;
    busy: boolean;
}

export function SizesToolbar({
    query,
    placeholder,
    onQueryChange,
    onExport,
    busy,
}: SizesToolbarProps) {
    return (
        <FilterBar>
            <FilterSearch
                value={query}
                placeholder={placeholder}
                onChange={onQueryChange}
            />

            <FilterSpacer />

            <Button
                icon={!busy ? <ExportIcon /> : undefined}
                onClick={onExport}
                disabled={busy}
            >
                <span className={styles.content}>
                    <span className={busy ? styles.hiddenText : undefined}>Выгрузить в Excel</span>

                    {busy && (
                        <span className={styles.spinnerWrapper}>
                            <IconSpinner className={styles.spinner} />
                        </span>
                    )}
                </span>
            </Button>
        </FilterBar>
    );
}